export const mappedFieldCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  minWidth: 0,
  wordBreak: 'break-word',
};
